/** The address of a post that was put up by hand. The server checks the same
 *  rule (an http or https link with a host); checking it here as well says so
 *  before the button is pressed. */

export const POST_URL_MESSAGE = '올린 글의 주소를 http:// 또는 https://로 시작하게 넣는다'

/** null when the text is a usable address, else the message to show. An empty
 *  field is not an error: the button simply stays off. */
export function postUrlError(raw: string): string | null {
  const v = raw.trim()
  if (!v) return null
  if (!/^https?:\/\//i.test(v)) return POST_URL_MESSAGE
  try {
    return new URL(v).host ? null : POST_URL_MESSAGE
  } catch {
    return POST_URL_MESSAGE
  }
}
